<template>
  <div>
    <nav v-if="breadcrumb" class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'service_plans'}">Service plans</router-link>
            <span class="mx-2">/</span>
            <div>{{ plan.name }}</div>
          </div>
          <div class="text-xl text-primary">
            {{ plan.name }}
          </div>
        </div>
        <div class="">
          <div class="inline-block relative float-right">
            <button @click="deletePlan" style="color: white !important;" v-if="$store.getters.can('delete_service_plan')"
                    class="bg-red-500 text-white hover:bg-teal-700 py-2 px-4 rounded-sm inline-flex items-center">
              Delete
            </button>
          </div>
        </div>
      </div>
    </nav>
    <div class="py-4 md:px-0 px-2">
      <div class="md:flex block">
        <div class="w-full rounded-lg  overflow-hidden  md:max-w-xs mb-3">
          <div class=" bg-white rounded-lg border shadow-sm">
            <div class="text-center px-3 pb-6 pt-2" v-if="plan.bandwidthPolicy">
              <h3 class="text-black text-sm bold font-sans">{{ plan.name || '' }}</h3>
              <p class="font-bold text-green-600" v-if="plan.free_internet">
                Free internet plan
              </p>
              <p>{{ plan.description }}</p>

              <div class="mt-4">
                <h3>Bandwidth policy: {{ plan.bandwidthPolicy.name }}</h3>
                <p class="text-grey-dark" v-if="plan.bandwidthPolicy.id">Downlink:
                  {{ plan.bandwidthPolicy.max_download + '' + plan.bandwidthPolicy.max_download_unit }} & Uplink:
                  {{ plan.bandwidthPolicy.max_upload + '' + plan.bandwidthPolicy.max_upload_unit }}</p>
              </div>
            </div>

            <ul class="mt-2 flex flex-wrap md:block">
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'service_plan', params: {id: planId, path:'details'}}" v-if="$store.getters.can('edit_service_plan')"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="edit" size="16" class="mr-4"/>
                  Update
                </router-link>
              </li>

              <li class="border-l-4 border-transparent  hover:border-teal-700 my-2 ">
                <div @click="deletePlan" v-if="$store.getters.can('delete_service_plan')"
                     class="block items-center flex lg:mt-0 px-3 h-8 text-red-500 hover:text-teal-700">
                  <feather type="trash" size="16" class="mr-4"/>
                  Delete
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="w-full mt-3 md:mt-0 md:mx-4 ">
          <CreateServicePlan :breadcrumb="false" :plan-id="plan.id" v-if="plan.id != null"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";
import CreateServicePlan from "@/modules/servicePlans/CreateServicePlan";

export default {
  name: "ServicePlan",
  components: {CreateServicePlan},
  data() {
    return {
      plan: Object
    }
  },
  props: {
    planId: String,
    path: String,
    breadcrumb: {default: true, type: Boolean}
  },
  mounted() {
    this.queryPlan();
  },

  methods: {
    queryPlan() {
      let plan = this.planId == 'free' ? 'freePlan' : 'servicePlan(id: "' + this.planId + '")';
      GraphQl.sendRequest('{' + plan + '{id name description free_internet bandwidthPolicy{id name max_download max_download_unit max_upload max_upload_unit} time_limit time_limit_unit usage_limit usage_limit_unit simultaneous_connections validity validity_units price}}')
          .then(response => {
            this.plan = this.planId == 'free' ? response.freePlan : response.servicePlan;
            if (this.planId == 'free' && this.plan == null)
              this.$router.replace({message: 'create_service_plan', params: {orgId: this.$store.getters.orgId,free: 'true'}});
          })
    },
    deletePlan() {
      let delConfirm = confirm("Are you sure you want to delete this service plan? This might affect all active subscriptions")
      if (delConfirm)
        GraphQl.sendRequest('mutation{deleteServicePlan(id: "' + this.plan.id + '"){code message}}')
            .then(response => {
              alert(response.deleteServicePlan.message);
              this.$router.push({message: 'service_plans'})
            })
    }
  }
}
</script>

<style scoped>

</style>